import { Backbone } from '../../vendor';
import Biscuit from "./Biscuit";
import showNotification from "../react/helpers/showNotification";

/**
 * @file IcsBuilder.js
 * @author Felix Albroscheit, May 2018
 * @description Requests /createICS endpoint and builds ics-file
 */
export default class {

    /**
     * @constructor
     * @param { object } options - passed to API endpoint
     * @param { string } filePrefix
     */
    constructor(options: any, filePrefix: string) {

        const icsHelper: any = new (Backbone.Collection.extend({
          url : '/ics/createICS'
        }));

        icsHelper.create(options, {
            headers: {
                'Accept-Language': Biscuit.get('user.lang').replace('-','_'),
                'Authorization': `Bearer ${Biscuit.get('token')}`
            },
            success (model: any, response: any): void {
                showNotification('',null, 'ICS will be created')

            },
            error (): void {
                alert('Failed to download the calendar file. Please try again later or contact the administrator.');
            }
        });
    }
}